declare global {
    interface Window {
        iconsLibrary?: Record<string, string>;
    }
}

const setPathInStorage = (pathKey: string, data: string): void => {
    if (window?.iconsLibrary) {
        window.iconsLibrary[pathKey] = data;
    }
    else if (window) {
        window.iconsLibrary = {};
        window.iconsLibrary[pathKey] = data;
    }
    else {
        /* do nothing */
    }
};

export default setPathInStorage;
